module.exports = __webpack_public_path__ + "img/contact.e5e1dc80.png";